export const findBestMatch = (
  value: number | null | undefined,
  values: Array<number>,
  typeOfSlider?: string
) => {
  if (value == null && typeOfSlider === 'min') {
    return 0;
  }

  if (value == null) {
    return values.length - 1;
  }

  return values.reduce(function (accumulator, current, currentIndex) {
    return Math.abs(current - value) < Math.abs(values[accumulator] - value)
      ? currentIndex
      : accumulator;
  }, 0);
};
